import { render, staticRenderFns } from "./MyDetails.vue?vue&type=template&id=1d1e7f12&lang=pug&"
import script from "./MyDetails.vue?vue&type=script&lang=ts&"
export * from "./MyDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports